import { inject, observer } from 'mobx-react';
import React from 'react';
import { useHistory } from 'react-router';
import { makeStyles } from 'tss-react/mui';

import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

import Hubspot from 'app/main/common/Hubspot';
import HubspotButton from 'app/main/common/HubspotButton';
import Utils from 'utils/Utils';

import Widgets from './Widgets';

const useStyles = makeStyles()({
    root: {
        padding: '0 100px',
        position: 'relative',
        overflow: 'hidden',
        top: -100,
        '@media (max-width: 1140px)': {
            padding: 'initial'
        },
        '@media (max-width: 720px)': {
            top: -50
        }
    },
    slide: {
        maxWidth: 1180,
        margin: '0 auto 32px',
        padding: '130px 80px',
        position: 'relative',
        background: '#FDF9F3',
        borderRadius: 28,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        flexWrap: 'wrap',
        '@media (max-width: 1140px)': {
            flexDirection: 'column-reverse',
            alignContent: 'center',
            margin: '0 auto 32px',
            padding: '40px 0 0',
            '&:nth-child(2)': {
                flexDirection: 'column'
            }
        }
    },
    box: {
        maxWidth: 480,
        '@media (max-width: 1140px)': {
            padding: 20
        }
    },
    title: {
        fontSize: 36
    },
    description: {
        fontSize: 18,
        paddingTop: 24,
        paddingBottom: 48
    },
    button: {
        fontSize: 16,
        padding: '16px 40px',
        borderRadius: 100,
        border: 'none'
    },
    img: {
        maxWidth: 460,
        '@media (max-width: 1140px)': {
            marginBottom: 40
        },
        '@media (max-width: 720px)': {
            maxWidth: '100%'
        }
    }
});

const Benefits = () => {
    const { classes } = useStyles();
    const history = useHistory();

    const handleClick = (e) => {
        e.preventDefault();
        window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });
        history.push('/feed');
    };

    return (
        <Box className={classes.root} id="feed">
            <Box className={classes.slide}>
                <Box display="flex" flexDirection="column" alignItems="flex-start" className={classes.box}>
                    <Typography className={classes.title} variant="h2">
                        Database of software vulnerabilities and exploits in one feed
                    </Typography>
                    <Typography className={classes.description} variant="body2">
                        Enrich your Security Operations with relevant, correlated, and ready-to-use vulnerability data
                        such as exploits, social networks buzz, and experts analysis. Focus your efforts only on threats
                        that matter
                    </Typography>
                    <HubspotButton
                        hubspot={Hubspot.LANDING_MAIN_FEED_LEARN_MORE}
                        className={classes.button}
                        variant="contained"
                        color="primary"
                        href="/feed"
                        onClick={handleClick}
                    >
                        Learn More
                    </HubspotButton>
                </Box>
                <img
                    src={Utils.getImage('landing/v2/benefit/feed')}
                    alt="Vulnerability Security Feed"
                    className={classes.img}
                />
            </Box>

            <Widgets />
        </Box>
    );
};

export default inject('statsStore')(observer(Benefits));
